import React from 'react'
import {KTSVG} from '../../../_metronic/helpers'

function OTHERCARD({title, message, date}: any) {
  return (
    <div className='d-lg-flex align-items-center '>
      <span className='svg-icon svg-icon-primary svg-icon-2x me-3'>
        {title !== 'Email Sent' ? (
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M17.8 20C17.4 21.2 16.3 22 15 22H5C3.3 22 2 20.7 2 19V18H14.2C14.6 19.2 15.7 20 17 20H17.8ZM19 2C20.7 2 22 3.3 22 5V6H20V5C20 4.4 19.6 4 19 4C18.4 4 18 4.4 18 5V18H17C16.4 18 16 17.6 16 17V16H5V5C5 3.3 6.3 2 8 2H19ZM8 6V8H15V6H8ZM8 10V12H14V10H8Z'
              fill='black'
            />
          </svg>
        ) : (
          <KTSVG path='/media/icons/email-sent.svg' className='svg-icon-2 svg-icon-gray-500' />
        )}
      </span>

      <div className='me-3 flex-grow-1 w-lg-75'>
        <div className='d-flex align-items-center'>
          <div className='text-gray-800 fw-bold'>{title} </div>
        </div>
        <div className='text-muted'>{message}</div>
      </div>
      <div className='text-dark fw-medium'>
        <div className='text-dark'>{date}</div>
      </div>
    </div>
  )
}

export default OTHERCARD
